webpackJsonp([10],{

/***/ "8Gg2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"year_option_wrapper":"year_option_wrapper__3dfgG","year_option_average":"year_option_average__2C8tE","form":"form__XPz23","year_option":"year_option__3rEfZ","year_option_label":"year_option_label__1F_0O","select_deselect_btns":"select_deselect_btns__TI4vS"};

/***/ }),

/***/ "a+Ge":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__("KM04");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_preact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notify_mounted__ = __webpack_require__("Oqou");


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




/**
 * The PanelGraph component handlers the rendering of a panel graph, which is not
 * rendered via Preact components, but with D3. It handles resizing too.
 *
 * props:
 * - graphFactory: factory function which returns a Graph object
 * - data: The data to be passed to the graph factory
 * - opts: extra options object to be passed to the graph factory
 */

var PanelGraph = function (_Component) {
	_inherits(PanelGraph, _Component);

	function PanelGraph(props, context) {
		_classCallCheck(this, PanelGraph);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.graphContainer = null;
		_this.graphContainerWidth = -1;
		_this.graph = null;
		return _this;
	}

	PanelGraph.prototype.update = function update(factory, data, opts) {
		this.graph = factory(data, this.graphContainer.getBoundingClientRect(), opts);
		this.graph.render(this.graphContainer);
	};

	PanelGraph.prototype.componentDidMount = function componentDidMount() {
		var _this2 = this;

		this.update(this.props.graphFactory, this.props.data, this.props.opts);

		this.resizeHandlerId = this.context.resize.addHandler(function () {

			var dim = _this2.graphContainer.getBoundingClientRect();

			// Only re-render the graph if the container width has actually changed.
			if (dim.width !== _this2.graphContainerWidth) {
				_this2.graphContainerWidth = dim.width;
				_this2.graphContainer.style.height = dim.height + 'px';
				_this2.graphContainer.innerHTML = '';
				_this2.graph.render(_this2.graphContainer);
				_this2.graphContainer.style.height = '';
			}
		});

		// This fixes behaviour on chrome (desktop + android) where touchmove events stop
		// We just need to add a listener for the  touchstart event on the document,
		// it doesn't actually need to do anything.
		this.documentTouchHandler = function () {};
		document.addEventListener('touchstart', this.documentTouchHandler);
	};

	PanelGraph.prototype.componentWillUnmount = function componentWillUnmount() {
		this.context.resize.removeHandler(this.resizeHandlerId);
		document.removeEventListener('touchstart', this.documentTouchHandler);
	};

	PanelGraph.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
		return false;
	};

	PanelGraph.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
		if (nextProps.data !== this.props.data || nextProps.opts !== this.props.opts || nextProps.graphFactory !== this.props.graphFactory) {
			this.update(nextProps.graphFactory, nextProps.data, nextProps.opts);
		}
	};

	PanelGraph.prototype.render = function render() {
		var _this3 = this;

		return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["h"])('div', { 'class': 'hw_panel_graph', ref: function ref(el) {
				_this3.graphContainer = el;
			} });
	};

	return PanelGraph;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__notify_mounted__["a" /* default */])(PanelGraph));

/***/ }),

/***/ "iBO4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../node_modules/preact/dist/preact.min.js
var preact_min = __webpack_require__("KM04");
var preact_min_default = /*#__PURE__*/__webpack_require__.n(preact_min);

// EXTERNAL MODULE: ../node_modules/d3-color/src/index.js + 5 modules
var src = __webpack_require__("Peej");

// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__("/R+W");

// CONCATENATED MODULE: ./routes/history-rainfall/reducers.js
var initialState = function initialState() {
	return {
		rainfall: undefined,
		rainfallLoading: false,
		rainfallRetryCount: -1,
		activeSeries: []
	};
};

var rainfallLoading = function rainfallLoading() {
	return {
		rainfallLoading: true
	};
};

var rainfallLoadSuccess = function rainfallLoadSuccess(data) {
	return {
		rainfall: data,
		rainfallLoading: false,
		rainfallRetryCount: -1,
		activeSeries: ['' + data.years[data.years.length - 1].year, 'average']
	};
};

var rainfallLoadFailure = function rainfallLoadFailure(currentRetryCount) {
	return {
		rainfall: null,
		rainfallLoading: false,
		rainfallRetryCount: currentRetryCount + 1
	};
};

var removeActiveSeries = function removeActiveSeries(currentActiveSeries, seriesName) {
	return {
		activeSeries: currentActiveSeries.filter(function (s) {
			return s !== seriesName;
		})
	};
};

var addActiveSeries = function addActiveSeries(currentActiveSeries, seriesName) {
	return {
		activeSeries: currentActiveSeries.concat(seriesName)
	};
};

var setAllSeriesActive = function setAllSeriesActive(data) {
	return {
		activeSeries: data.years.map(function (d) {
			return '' + d.year;
		}).concat('average')
	};
};

var setAllSeriesInactive = function setAllSeriesInactive() {
	return {
		activeSeries: []
	};
};
// EXTERNAL MODULE: ./components/handle-loading-and-error/index.js + 1 modules
var handle_loading_and_error = __webpack_require__("/zgt");

// EXTERNAL MODULE: ../node_modules/d3-shape/src/index.js + 51 modules
var d3_shape_src = __webpack_require__("9maw");

// EXTERNAL MODULE: ./utils/formatters.js
var formatters = __webpack_require__("gNwm");

// EXTERNAL MODULE: ./utils/panelgraph/components/axis-x.js
var axis_x = __webpack_require__("nTP0");

// EXTERNAL MODULE: ./utils/panelgraph/components/series.js
var components_series = __webpack_require__("PhSF");

// EXTERNAL MODULE: ./utils/panelgraph/components/axis-y.js
var axis_y = __webpack_require__("N0ou");

// EXTERNAL MODULE: ./utils/panelgraph/components/panel.js
var panel = __webpack_require__("vNH8");

// EXTERNAL MODULE: ./utils/panelgraph/components/plot-line.js
var plot_line = __webpack_require__("1zZQ");

// EXTERNAL MODULE: ./utils/panelgraph/components/graph.js + 21 modules
var graph = __webpack_require__("bv0A");

// EXTERNAL MODULE: ./utils/date-utils.js
var date_utils = __webpack_require__("Z83D");

// EXTERNAL MODULE: ./utils/panelgraph/constants.js
var constants = __webpack_require__("gmeS");

// CONCATENATED MODULE: ./components/yearly-rain-graph/graph-factory.js












var graph_factory_yearlyRainfallGraphFactory = function yearlyRainfallGraphFactory(data, containerBoundingRect, opts) {
	var rainUnit = opts.rainUnit,
	    colors = opts.colors,
	    activeSeries = opts.activeSeries;


	var monthNames = Object(date_utils["a" /* getMonthNames */])();

	var transformedData = data.average.map(function (avg) {

		var mmdd = avg.date;
		var monthNum = parseInt(mmdd.slice(0, 2), 10);
		var day = parseInt(mmdd.slice(3), 10);

		var pt = {
			day: avg.day,
			date: day + ' ' + monthNames[monthNum - 1]
		};

		if (activeSeries.indexOf('average') !== -1) {
			pt.average = avg.rainfall;
		}

		return pt;
	});

	data.years.forEach(function (yearData) {

		if (activeSeries.indexOf('' + yearData.year) !== -1) {
			var seriesKey = '' + yearData.year;

			yearData.values.forEach(function (value) {
				var index = value.day - 1;
				transformedData[index][seriesKey] = value.rainfall;
			});
		}
	});

	var tickValues = transformedData.filter(function (d) {
		return d.date.slice(0, 2) === '1 ';
	}).map(function (d) {
		return d.day;
	});

	// small window size needs less ticks.
	if (containerBoundingRect.width < 640) {
		tickValues = tickValues.filter(function (t, i) {
			return i % 3 === 0;
		});
	}

	var xAxisFormatter = function xAxisFormatter(day) {
		var record = transformedData.filter(function (d) {
			return d.day === day;
		})[0];
		return record.date.slice(2, 5);
	};

	var tooltipFormatter = function tooltipFormatter(pt) {
		return pt.date;
	};

	var dateAxis = Object(axis_x["a" /* xAxis */])().data(function (pt) {
		return pt.day;
	}).range([transformedData[0].day, transformedData[transformedData.length - 1].day]).tooltipFormatter(tooltipFormatter).tickValues(tickValues).formatter(xAxisFormatter);

	var series = [];

	data.years.forEach(function (yearData, index) {
		var year = yearData.year;

		if (activeSeries.indexOf('' + year) !== -1) {
			series.push(Object(components_series["b" /* lineSeries */])('yearly_rainfall_' + year).color(colors[index]).curve(d3_shape_src["curveStep"]).data(function (pt) {
				return pt[year] === null ? null : pt[year];
			}).label('' + year).tooltipFormatter(function (pt) {
				return Object(formatters["e" /* formatRainfall */])(pt[year], rainUnit) + ' ' + rainUnit;
			}));
		}
	});

	if (activeSeries.indexOf('average') !== -1) {

		var avgSeries = Object(components_series["b" /* lineSeries */])('yearly_rainfall_average').curve(d3_shape_src["curveLinear"]).data(function (pt) {
			return pt.average === null ? null : pt.average;
		}).label('Mean').tooltipFormatter(function (pt) {
			return Object(formatters["e" /* formatRainfall */])(pt.average, rainUnit) + ' ' + rainUnit;
		});

		series.push(avgSeries);
	}

	var rainAxis = Object(axis_y["a" /* yAxis */])().formatter(function (v) {
		return Math.round(v);
	}).constraints({
		fixedMinValue: 0,
		stepOptions: [100, 200, 250, 400, 500]
	});

	var rainPanel = Object(panel["a" /* panel */])().series(series).axisDual(rainAxis);

	var plotLines = tickValues.map(function (value) {
		return Object(plot_line["a" /* plotLine */])().x(value - 0.5);
	});

	// We'll disabled to legend and create our own interactive one.
	return Object(graph["a" /* graph */])('yearly_rainfall').margin([15, 45, 20, 45]).height(function (w) {
		return Math.max(300, 0.66 * w);
	}).data(transformedData).xAxis(dateAxis).panels([rainPanel]).plotLines(plotLines).legendEnabled(false).tooltipMode(constants["a" /* TOOLTIP_MODE */].COMBINED_REVERSE);
};
// EXTERNAL MODULE: ./components/panelgraph/index.js
var panelgraph = __webpack_require__("a+Ge");

// CONCATENATED MODULE: ./components/yearly-rain-graph/index.js


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var yearly_rain_graph_YearlyRainGraph = function (_Component) {
	_inherits(YearlyRainGraph, _Component);

	function YearlyRainGraph(props, context) {
		_classCallCheck(this, YearlyRainGraph);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.factory = graph_factory_yearlyRainfallGraphFactory;
		return _this;
	}

	YearlyRainGraph.prototype.render = function render(props) {
		var opts = {
			rainUnit: props.rainUnit,
			colors: props.colors,
			activeSeries: props.activeSeries
		};

		return Object(preact_min["h"])(panelgraph["a" /* default */], { data: props.data,
			opts: opts,
			graphFactory: this.factory,
			mounted: this.props.mounted });
	};

	return YearlyRainGraph;
}(preact_min["Component"]);

/* harmony default export */ var yearly_rain_graph = (Object(handle_loading_and_error["a" /* default */])(yearly_rain_graph_YearlyRainGraph));
// EXTERNAL MODULE: ./components/icons/checkbox.js
var icons_checkbox = __webpack_require__("OzCj");

// EXTERNAL MODULE: ./routes/history-rainfall/style.scss
var style = __webpack_require__("8Gg2");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./components/page-title/index.js
var page_title = __webpack_require__("O7V0");

// EXTERNAL MODULE: ./utils/tracking.js
var tracking = __webpack_require__("x4D6");

// CONCATENATED MODULE: ../node_modules/babel-loader/lib??ref--0!./routes/history-rainfall/index.js


function history_rainfall__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function history_rainfall__possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function history_rainfall__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












/**
 * The HistoryRainfallPage component is a route component, controlling the rainfall history view.
 */

var _ref = Object(preact_min["h"])(
	page_title["a" /* default */],
	null,
	'Yearly Rainfall'
);

var _ref2 = Object(preact_min["h"])(
	'p',
	null,
	'The graph below displays yearly rainfall accumulating daily recorded by the weather station. The bold black line shows the average (mean) for comparison. Note that for leap years, any rainfall on the 29th of February is combined with the 28th.'
);

var history_rainfall_HistoryRainfallPage = function (_Component) {
	history_rainfall__inherits(HistoryRainfallPage, _Component);

	function HistoryRainfallPage(props, context) {
		history_rainfall__classCallCheck(this, HistoryRainfallPage);

		var _this = history_rainfall__possibleConstructorReturn(this, _Component.call(this, props, context));

		_this.state = initialState();

		_this.colors = null;

		_this.loadRainfall = _this.loadRainfall.bind(_this);
		_this.onToggle = _this.onToggle.bind(_this);
		_this.selectAllSeries = _this.selectAllSeries.bind(_this);
		_this.deselectAllSeries = _this.deselectAllSeries.bind(_this);

		_this.requestAbort = {
			rainfall: null
		};
		return _this;
	}

	HistoryRainfallPage.prototype.loadRainfall = function loadRainfall() {
		var _this2 = this;

		this.setState(rainfallLoading());

		var params = {
			years: 'all',
			leapYearMerge: 1,
			average: 1
		};

		var request = Object(api["q" /* fetchYearlyRainfall */])(params);
		this.requestAbort.rainfall = request.abort;

		request.promise.then(function (res) {
			var hueStep = 360 / res.data.years.length;
			_this2.colors = res.data.years.map(function (d, i) {
				return Object(src["hsl"])(i * hueStep, 1, 0.4).toString();
			});

			_this2.setState(rainfallLoadSuccess(res.data));
		}).catch(function (err) {
			if (err.name !== api["a" /* ABORT_ERROR_NAME */]) {
				_this2.setState(function (state) {
					return rainfallLoadFailure(state.rainfallRetryCount);
				});
				_this2.context.tracking.recordException('Error loading yearly rainfall data', err);
			}
		});
	};

	HistoryRainfallPage.prototype.componentDidMount = function componentDidMount() {
		this.loadRainfall();

		this.context.titleService.update('Rainfall History');
		this.context.tracking.recordPageView();
	};

	HistoryRainfallPage.prototype.componentWillUnmount = function componentWillUnmount() {
		Object(api["b" /* abortRequests */])(this.requestAbort);
	};

	HistoryRainfallPage.prototype.isSeriesActive = function isSeriesActive(name) {
		return this.state.activeSeries.indexOf(name) !== -1;
	};

	HistoryRainfallPage.prototype.onToggle = function onToggle(evt) {
		if (evt.type === 'keyup' && evt.keyCode !== 13) {
			return;
		}

		var node = evt.target;

		while (!node.hasAttribute('data-series')) {
			node = node.parentNode;
		}

		var seriesName = node.getAttribute('data-series');
		var isActive = this.isSeriesActive(seriesName);

		if (isActive) {
			this.setState(function (state) {
				return removeActiveSeries(state.activeSeries, seriesName);
			});
		} else {
			this.setState(function (state) {
				return addActiveSeries(state.activeSeries, seriesName);
			});
		}

		this.context.tracking.recordEvent(isActive ? tracking["a" /* EVENT_ACTION */].HISTORY_RAINFALL_HIDE_YEAR : tracking["a" /* EVENT_ACTION */].HISTORY_RAINFALL_SHOW_YEAR, tracking["b" /* EVENT_CATEGORY */].HISTORY_RAINFALL, 'series: ' + seriesName);
	};

	HistoryRainfallPage.prototype.selectAllSeries = function selectAllSeries() {
		this.setState(function (state) {
			return setAllSeriesActive(state.rainfall);
		});
	};

	HistoryRainfallPage.prototype.deselectAllSeries = function deselectAllSeries() {
		this.setState(function () {
			return setAllSeriesInactive();
		});
	};

	HistoryRainfallPage.prototype.renderToggleForm = function renderToggleForm() {
		var _this3 = this;

		if (!this.state.rainfall) {
			return null;
		}

		return Object(preact_min["h"])(
			'form',
			{ 'class': style_default.a.form },
			Object(preact_min["h"])(
				'div',
				{ 'class': style_default.a.year_option_wrapper },
				Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.year_option_average,
						'data-series': 'average',
						onClick: this.onToggle,
						onKeyUp: this.onToggle,
						role: 'checkbox',
						tabIndex: 0,
						'aria-checked': this.isSeriesActive('average') },
					Object(preact_min["h"])(icons_checkbox["a" /* default */], { checked: this.isSeriesActive('average') }),
					Object(preact_min["h"])(
						'span',
						{ 'class': style_default.a.year_option_label },
						'Mean'
					)
				)
			),
			this.state.rainfall.years.map(function (yearData, index) {
				return Object(preact_min["h"])(
					'div',
					{ 'class': style_default.a.year_option_wrapper },
					Object(preact_min["h"])(
						'div',
						{ 'class': style_default.a.year_option,
							'data-series': yearData.year,
							onClick: _this3.onToggle,
							onKeyUp: _this3.onToggle,
							role: 'checkbox',
							tabIndex: 0,
							'aria-checked': _this3.isSeriesActive('' + yearData.year) },
						Object(preact_min["h"])(icons_checkbox["a" /* default */], { fill: _this3.colors[index], checked: _this3.isSeriesActive('' + yearData.year) }),
						Object(preact_min["h"])(
							'span',
							{ 'class': style_default.a.year_option_label },
							yearData.year
						)
					)
				);
			}).reverse()
		);
	};

	HistoryRainfallPage.prototype.render = function render() {
		return Object(preact_min["h"])(
			'div',
			null,
			_ref,
			_ref2,
			Object(preact_min["h"])(yearly_rain_graph, { data: this.state.rainfall,
				rainUnit: this.context.userSettings.units.rain,
				activeSeries: this.state.activeSeries,
				colors: this.colors,
				isLoading: this.state.rainfallLoading,
				retryCount: this.state.rainfallRetryCount,
				errorMessage: 'Unable to load yearly rainfall data',
				retryHandler: this.loadRainfall }),
			this.renderToggleForm(),
			Object(preact_min["h"])(
				'div',
				{ className: style_default.a.select_deselect_btns },
				Object(preact_min["h"])(
					'button',
					{ onClick: this.selectAllSeries },
					'Select all'
				),
				Object(preact_min["h"])(
					'button',
					{ onClick: this.deselectAllSeries },
					'Deselect all'
				)
			)
		);
	};

	return HistoryRainfallPage;
}(preact_min["Component"]);

/* harmony default export */ var history_rainfall = __webpack_exports__["default"] = (history_rainfall_HistoryRainfallPage);

/***/ })

});


// WEBPACK FOOTER //
// route-history-rainfall.chunk.b97fa.js